<template>
  <v-dialog
      v-model="linking.show"
      persistent
      max-width="320"
  >
    <v-card>
      <v-card-title>
        <span v-if="settings.copy">{{ $t('system.linking.actions.copy') }}</span>
        <span v-else>{{ $t('system.linking.actions.follow') }}</span>
      </v-card-title>
      <v-card-subtitle>
        {{ settings.name }}
      </v-card-subtitle>

      <v-card-text>
        <v-form
            ref="linking-form"
            lazy-validation
        >
          <v-row>
            <v-col cols="12">
              <v-select
                  v-model="settings.radar"
                  :items="radars"
                  item-text="name"
                  item-value="id"
                  :label="$t('form.blob.radar.label')"
                  @change="updateSelectedRadar"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  v-model="settings.quadrant"
                  :items="quadrants"
                  item-text="text"
                  item-value="value"
                  :label="$t('form.blob.quadrants.label')"
                  :disabled="!valid"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  v-model="settings.sector"
                  :items="sectors"
                  item-text="text"
                  item-value="value"
                  :label="$t('form.blob.sectors.label')"
                  :disabled="!valid"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn
            text
            @click="close"
        >
          {{ $t('controls.cancel') }}
        </v-btn>

        <v-spacer></v-spacer>

        <v-btn
          :dark="valid"
          :outlined="!valid"
          :disabled="!valid"
          @click="createLinking"
        >
          <span>
            {{ $t('controls.save') }}
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Linking',
  data: function () {
    return {
      show: false,
      settings: {},
      quadrants: [],
      sectors: [],
    }
  },
  computed: {
    ...mapGetters({
      linking: 'linking/getLinking',
      radars: 'radars/getRadars'
    }),
    valid() {
      return this.settings.radar > 0
    }
  },
  methods: {
    close() {
      this.settings = {};
      this.$store.commit('linking/closeLinking')
    },

    updateSelectedRadar(id) {
      let radar = this.radars.find(r => r.id === id)

      if(radar === undefined)
        return;

      this.quadrants = [{ text: radar.quadrant_0, value: 0}, { text: radar.quadrant_1 , value: 1}, { text: radar.quadrant_2, value: 2 }, { text: radar.quadrant_3, value: 3 }];
      this.sectors = [{ text: radar.sector_0, value: 0}, { text: radar.sector_1, value: 1 }, { text: radar.sector_2, value: 2 }, { text: radar.sector_3, value: 3 }];
    },

    createLinking() {
      if(this.settings.copy) {
        this.$store.dispatch('linking/copyBlob', this.settings)
          .then(() => {
            // remove blob from suggestions (suggestions can only be once by a user)
            this.$store.commit('suggestion/removeBlob', this.settings.blobId);

            this.$store.commit('notification/newNotification', {
              text: this.$t('form.blob-suggestion.copied')
            })
            this.close();
          })
      } else {
        this.$store.dispatch('linking/followBlob');
      }
    }
  },

  watch: {
    linking: {
      deep: true,
      handler () {
        this.show = this.linking.show;
        this.settings = Object.assign({}, this.linking);
      }
    }
  }
}
</script>

<style scoped>

</style>
